import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutOrderAutoRateLookup } from "./autogen/AutogenLayoutOrderAutoRateLookup";

export class OrderAutoRateLookup extends AutogenLayoutOrderAutoRateLookup {
    tableRateLookupOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        //Null tooltips for the following components to prevent quick info inside lookup model layout
        const textboxCustomerId = tableRow.findComponentById("textboxCustomerId");
        if (textboxCustomerId) textboxCustomerId.allowTooltip = false;

        const textboxOrderType = tableRow.findComponentById("textboxOrderType");
        if (textboxOrderType) textboxOrderType.allowTooltip = false;

        const textboxRevenueCodeId = tableRow.findComponentById("textboxRevenueCodeId");
        if (textboxRevenueCodeId) textboxRevenueCodeId.allowTooltip = false;
    }
}
